var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M9 0c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zm0 1.125C4.658 1.125 1.125 4.658 1.125 9c0 4.342 3.533 7.875 7.875 7.875 4.342 0 7.875-3.533 7.875-7.875 0-4.342-3.533-7.875-7.875-7.875zM9 13.05c.414 0 .75.336.75.75s-.336.75-.75.75-.75-.336-.75-.75.336-.75.75-.75zM9 3.3c1.758 0 3.188 1.43 3.188 3.188 0 1.25-.988 2.579-2.25 3.024-.225.08-.376.293-.376.531v.757c0 .31-.252.563-.562.563-.31 0-.563-.252-.563-.563v-.757c0-.714.454-1.354 1.127-1.592.896-.316 1.498-1.27 1.498-1.963 0-1.138-.924-2.063-2.062-2.063s-2.063.925-2.063 2.063c0 .31-.252.562-.562.562-.31 0-.563-.252-.563-.562C5.812 4.73 7.242 3.3 9 3.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/more-info.cd2e4488736c6f0b7b75b155d23548c7.svg";
export { ForwardRef as ReactComponent };